// extracted by mini-css-extract-plugin
export default {"outerContainer":"musicplaybutton_outerContainer__hOQxi","container":"musicplaybutton_container__V9z9l","playButton":"musicplaybutton_playButton__VQWDj"};